import fetchClient from '../Services/fetchClient';
import { clearClientContactForEdit } from '../State/clientConactForEdit';

export default () => async (dispatch) => {

  dispatch(fetchClient());
  dispatch(clearClientContactForEdit());
}